import Vue from 'vue';
import { ImagesApiService } from '../../common/services/images.api.service';
import { ImageModel } from '../../common/models/image.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: { items: [], status: REQUEST_STATUS.LOADING },
  getters: {
    getAll: state => state.items,
    getItemById: state => id => state.items.find(item => item.id === id),
    getStatus: state => state.status,
  },
  mutations: {
    SET_ITEMS(state, images) {
      state.items = images;
    },
    SET_ITEM(state, image) {
      const arrayIndex = state.items.findIndex(item => item.id === image.id);

      if (arrayIndex === -1) {
        Vue.set(state.items, state.items.length, image);
      } else {
        Vue.set(state.items, arrayIndex, image);
      }
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAll({ commit, dispatch }, { ids, resize = null, fitCanvas = null }) {
      commit('FETCH_REQUEST');
      return ImagesApiService.getAll(builder => {
        if (resize) {
          builder.setParam('resize', resize);
        }
        if (fitCanvas) {
          builder.setParam('fit_canvas', fitCanvas);
        }

        builder.whereIn([ImageModel.ATTR_ID], ids);
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('FETCH_SUCCESS');
          return Promise.resolve(response.getItems());
        })
        .catch(error => {
          dispatch('handleError', error);
          return Promise.reject(error.getMessage());
        });
    },

    fetchById({ commit, dispatch }, { id, resize = null, fitCanvas = null }) {
      if (!id) {
        return Promise.reject('No id provided');
      }

      commit('FETCH_REQUEST');
      return ImagesApiService.get(id, builder => {
        if (resize) {
          builder.setParam('resize', resize);
        }
        if (fitCanvas) {
          builder.setParam('fit_canvas', fitCanvas);
        }
      })
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
          return Promise.resolve(response.getItem());
        })
        .catch(error => {
          dispatch('handleError', error);
          return Promise.reject(error.getMessage());
        });
    },

    getById({ dispatch, getters }, id) {
      const existingImage = getters.getItemById(id);
      if (existingImage) {
        return Promise.resolve(existingImage);
      } else {
        return dispatch('fetchById', { id })
          .then(() => Promise.resolve(getters.getItemById(id)))
          .catch(error => {
            dispatch('handleError', error);
          });
      }
    },

    deleteImage({ dispatch }, id) {
      return ImagesApiService.delete(id)
        .then(() => Promise.resolve())
        .catch(error => {
          dispatch('handleError', error);
        });
    },

    handleError({ commit }, error) {
      commit('FETCH_FAIL');
      const message = error.getFirstValidationErrorMessage() || error.getMessage();
      this.$app.$alertError(message);
    },
  },
};
